import styles from "./MyDesiFamily.module.scss";
import Layout from "../../Components/Layout/Layout";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import AlphaSlider from "../../Components/Sliders/AlphaSlider/AlphaSlider";
import { CouponSlider } from "../LandingV2/LandingV2";
import React from "react";
import { useNewProducts } from "../../Hooks/useProductsBySubCategory";
import ProductSlider from "../../Components/Sliders/ProductSlider/ProductSlider";
import { Button, Col, Input, Row } from "antd";
import { MdEmail } from "react-icons/md";

const MyDesiFamily = () => {
    const { products } = useNewProducts();

    const slider_1 = [
        {
            img: "/family/df_banner.png",
        },
        {
            img: "/family/df_banner.png",
        },
    ];
    return (
        <Layout>
            <div style={{ padding: "0 1.5rem" }}>
                <BreadCrumb
                    list={[
                        {
                            name: "Home",
                            link: "/",
                        },
                        {
                            name: "My Desi Family Card",
                            link: "/customer/my-desi-family",
                        },
                    ]}
                />
            </div>

            <div className={styles.alpha}>
                <AlphaSlider slides={slider_1} dotS={true} dt_slides={slider_1} />
                <div className={styles.alpha_info}>
                    <span>My Rewards</span>
                    <img src="/family/trophy.svg" alt="" />
                    <div>
                        <span>789</span>
                        <img src="/icon/points-icon.svg" alt="" />
                    </div>
                </div>
            </div>

            <CouponSlider />

            <ProductSlider title="Desi Exclusive" link="/" products={products} />
            <br />
            <div className={styles.com}>
                <h2>Join a community</h2>
                <Row gutter={[10, 10]}>
                    <Col xs={12}>
                        <div className={styles.com__item}>
                            <img src="/family/df_d1.png" alt="" />
                            <div className={styles.com__item__country}>
                                <img src="https://flagicons.lipis.dev/flags/4x3/in.svg" alt="" />
                                <span>India</span>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12}>
                        <div className={styles.com__item}>
                            <img src="/family/df_d_2.png" alt="" />
                            <div className={styles.com__item__country}>
                                <img src="https://flagicons.lipis.dev/flags/4x3/pk.svg" alt="" />
                                <span>Pakistan</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <br />

            <ProductSlider title="Festival Special" link="/" products={products} />

            <br />

            <div className={styles.refer}>
                <h2>Refer a friend</h2>
                <img src="/family/refer.svg" alt="" />
                <div>
                    1 Refer = 100 <img src="/icon/points-icon.svg" alt="" />
                </div>
                <p>Your friend gets 100 points on sign up and you also get 100 points!</p>
                <Input prefix={<MdEmail />} placeholder={"Email address"} />
                <Button type={"primary"}>Sent Invite</Button>
            </div>
        </Layout>
    );
};

export default MyDesiFamily;
